var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-form",
              {
                ref: "formRef",
                staticClass: "company-info_form",
                attrs: {
                  inline: false,
                  model: _vm.form,
                  "label-width": "80px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "合同编号", prop: "orderid" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入合同编号" },
                      model: {
                        value: _vm.form.orderid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "orderid", $$v)
                        },
                        expression: "form.orderid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户名称", prop: "company" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户名称" },
                      model: {
                        value: _vm.form.company,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "company", $$v)
                        },
                        expression: "form.company",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "联系人", prop: "name" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "请输入联系人", clearable: "" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { slot: "prepend" },
                            nativeOn: {
                              click: function ($event) {
                                _vm.showContacts = true
                              },
                            },
                            slot: "prepend",
                          },
                          [_vm._v("请选择联系人")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "联系方式", prop: "phone" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入联系方式", clearable: "" },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "phone", _vm._n($$v))
                        },
                        expression: "form.phone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "运输方式", prop: "" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入运输方式" },
                      model: {
                        value: _vm.form.ysfs,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ysfs", $$v)
                        },
                        expression: "form.ysfs",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "交货地址", prop: "company" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入交货地址" },
                      model: {
                        value: _vm.form.company,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "company", $$v)
                        },
                        expression: "form.company",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%", "margin-bottom": "10px" },
                        attrs: { data: _vm.modelList, border: "" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "品牌", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入品牌" },
                                    model: {
                                      value: scope.row.source,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "source", $$v)
                                      },
                                      expression: "scope.row.source",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "型号", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入型号" },
                                    model: {
                                      value: scope.row.xhname,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "xhname", $$v)
                                      },
                                      expression: "scope.row.xhname",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "数量", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入数量" },
                                    model: {
                                      value: scope.row.num,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "num", $$v)
                                      },
                                      expression: "scope.row.num",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "备注", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入备注" },
                                    model: {
                                      value: scope.row.bz,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "bz", $$v)
                                      },
                                      expression: "scope.row.bz",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "el-icon-delete",
                                      attrs: { type: "danger", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemove(scope.$index)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("重 置"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("生 成")]
                ),
              ],
              1
            ),
            _vm.showContacts
              ? _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.showContacts,
                      title: "选择联系人",
                      width: _vm.getIsMobile ? "100%" : "70%",
                      "append-to-body": true,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.showContacts = $event
                      },
                    },
                  },
                  [
                    _c("Contacts", {
                      ref: "contactsRef",
                      attrs: { "contract-id": _vm.id },
                      on: { childContact: _vm.getChildContact },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }